import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  type UseInstallationsScoreParams,
  useInstallationsScore,
} from '../../hooks/useInstallationsScore';

import { InstallationsCard } from './InstallationsCard';

export const InstallationsCardContainer: React.FC<
  UseInstallationsScoreParams & { href?: string }
> = ({ href, ...params }) => {
  const { i18n } = useTranslation();
  const {
    percent,
    underperforming,
    total,
    isLoading,
    isError,
    isEmpty,
    retry,
  } = useInstallationsScore(params);

  return (
    <InstallationsCard
      percent={percent.toLocaleString(i18n.language)}
      underperforming={underperforming}
      total={total}
      isLoading={isLoading}
      isError={isError}
      isEmpty={isEmpty}
      onRetry={retry}
      href={href}
    />
  );
};
